<template>
  <div class="checkTel">
      <img src="/static/img/checkTel.png" alt="">
      <input v-model="phone" :readonly="readonly" maxlength="11" type="tel" id="tel" placeholder="手机号">
      <p>
          <input v-model="code" maxlength="6" type="tel" id="yzm" placeholder="验证码">
          <span v-show="sendAuthCode" @click="acquire" href="javascript:;">获取验证码</span>
          <span class="dumiao" v-show="!sendAuthCode" href="javascript:;">{{auth_time + '秒后重新获取'}}</span>
      </p>
      <input @click="sub" :disabled="this.nump !== 1 || !this.code" type="button" class="commit" value="提交">
  </div>
</template>
<script>
export default {
  data () {
    return {
      sendAuthCode: true,
      phone: '',
      code: '',
      readonly:false,
      nump: 0,
      auth_time: 0
    }
  },
  methods: {
    acquire () {
      const _this = this
      const reg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/
      if (_this.phone.length === '') {
        alert('请输入手机号')
      } else if (!reg.test(_this.phone)) {
        alert('请输入正确的手机号')
      } else {
        _this.readonly = true
        _this.sendAuthCode = false
        _this.auth_time = 60
        const auth_timetimer = setInterval(() => {
          this.auth_time--
          if (this.auth_time <= 0) {
            this.sendAuthCode = true
            clearInterval(auth_timetimer)
          }
        }, 1000)
        _this.nump = 1
        _this.postRequest('user/sendVerificationCode', {
          phone: this.phone
        },function (data) {
          alert('验证码获取成功')
        })
      }
    },
    refresh () {
      const _this = this
      _this.postRequest('house/queryAndSaveByPhone',{},function (data) {
        if(data.length <= 0){
          alert('您没有房产信息，请更换手机号')
          _this.sendAuthCode = false
          _this.phone = ''
          _this.code = ''
          _this.readonly = false
        }else{
          sessionStorage.setItem('el',data[0].name)
          sessionStorage.setItem('houseid',data[0].id)
        }
        let url = sessionStorage.getItem('home')
        _this.$router.push({name: url})
      })
    },
    sub () {
      const _this = this
      _this.postRequest('user/validatePhone', {
        phone: _this.phone,
        code: _this.code
      },function (data) {
        sessionStorage.setItem('phone', _this.phone)
        console.log('缓存中的手机号'+sessionStorage.getItem('phone'))
        _this.refresh ()
      })
    }
  }
}
</script>
<style scoped>
.checkTel{
    width: 100%;
    height: 100%;
    text-align: center;
    background-color: #fff;
}
.checkTel img{
    display: block;
    width: 100%;
    height: 330px;
}
::-webkit-input-placeholder{
    font-size: 28px;
    color:#333;
}
.checkTel #tel{
    width: 92%;
    height: 108px;
    border-bottom: 1px solid #d3d3d3;
    box-sizing: border-box;
    font-size: 35px;
}
.checkTel #yzm{
    height: 127px;
    font-size: 35px;
}
.checkTel p {
    text-align: center;
    margin-bottom: 200px;
    position: relative;
}
.checkTel p input{
    height: 110px;
    width: 92%;
    border-bottom: 1px solid #d3d3d3;
    box-sizing: border-box;
}
.checkTel p span{
    position:absolute;
    right: 30px;
    margin-top: 40px;
    color: #1B82D1;
    font-size: 28px;
}
.checkTel p .dumiao{
   color: #cdcdcd;
}
.checkTel .commit {
    width: 680px;
    height: 90px;
    border-radius: 50px;
    color: #fff;
    font-size:32px;
    letter-spacing: 20px;
    background-color: #1B82D1;
}
.checkTel .commit:disabled{
    background-color: #cdcdcd;
}
</style>



// WEBPACK FOOTER //
// src/components/pub-component/my/checkTel1.vue